import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { FullPhoto } from 'feature/personalize/FullPhoto'
import { personalize_banner } from 'feature/personalize/store'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { saveCancel, saveDont } from './util'

export const PersonalizeBanner = observer(() => {
  const banner = personalize_banner.it
  const { profile } = banner

  const onCancel = useLatestCallback(async () => {
    saveCancel(profile.identity_id)
    personalize_banner.it.profile.reset()
    personalize_banner.close()
  })

  const onUpload = useLatestCallback(() => {
    controller.personalizeInference()
  })

  const onDontShow = useLatestCallback(() => {
    saveDont(profile.identity_id)
    personalize_banner.close()
  })

  const dont = <Button large text action={onDontShow}>
    <Typo size={14} medium upper>
      {i18n('DontAskAgain')}
    </Typo>
  </Button>

  if (banner.photo) return <FullPhoto />

  return <Banner title={i18n('PersonalizeYourExperience')} onCancel={onCancel}>
    <Typo size={14} secondary>
      {i18n('UploadFullBodyPhotoForAccurateResult')}
    </Typo>
    <Gap height={16} />
    <Button large primary action={onUpload}>
      <Typo size={14} medium upper>
        {i18n('UploadYourPhoto')}
      </Typo>
    </Button>
    <Gap height={12} />
    <Button large flat action={onCancel}>
      <Typo size={14} medium upper>
        {i18n('Cancel')}
      </Typo>
    </Button>
    <Gap height={12} />
    {dont}
  </Banner>
})
